/* N1 · Comparador: añade la fila "Rendimiento" (natural / artificial / mojado) por palma.
   Se apoya en window.N1Perf (n1-perf.js), que guarda el texto de cada palma.
   07/10/2026 (multidioma fase 2, lote 3b): etiquetas desde window.N1T (n1.perf.*). */
(function(){
if(window.N1PerfCmp)return;window.N1PerfCmp=1;
var T=function(k,d){var v=window.N1T&&window.N1T[k];return (typeof v==='string'&&v&&!/translation missing/i.test(v))?v:d},F=function(s,o){return String(s).replace(/\{(\w+)\}/g,function(m,k){return o&&o[k]!=null?o[k]:m})};
function data(root){
  var s=root.closest('#n1k-cpop')?document.getElementById('cmpdpop'):[].slice.call(document.querySelectorAll('script[type="application/json"]')).filter(function(x){return /^cmpd/.test(x.id)})[0];
  if(!s)return null;try{return JSON.parse(s.textContent)}catch(e){return null}
}
function cell(t){
  return '<b>'+T('n1.perf.natural','Natural')+':</b> '+t.n+'<br><b>'+T('n1.perf.artificial','Artificial')+':</b> '+t.a+'<br><b>'+T('n1.perf.wet','Mojado')+':</b> '+t.m;
}
function run(){
  if(!window.N1Perf)return;
  [].slice.call(document.querySelectorAll('.n1-compare')).forEach(function(root){
    var rows=root.querySelector('[data-rows]');if(!rows)return;
    if(rows.querySelector('.n1-perfrow'))return;
    var on=[].slice.call(root.querySelectorAll('.chip.on')).map(function(c){return c.getAttribute('data-h')});
    if(on.length<2)return;
    var D=data(root);if(!D)return;
    var items=on.map(function(h){for(var i=0;i<D.items.length;i++)if(D.items[i].h===h)return D.items[i];return null}).filter(Boolean);
    if(items.length<2)return;
    var txts=items.map(function(x){return window.N1Perf.text((x.specs||{}).palma)});
    if(txts.some(function(t){return !t}))return;
    var same=txts.every(function(t){return t===txts[0]});
    var html='<div class="row n1-perfrow '+(same?'':'diff')+'"><div class="lb">'+T('n1.perf.title','Rendimiento')+'</div><div class="vals" style="--n:'+items.length+'">'
      +items.map(function(x,i){return '<div><em>'+x.t+'</em>'+cell(txts[i])+'</div>'}).join('')
      +'</div></div>';
    rows.insertAdjacentHTML('beforeend',html);
  });
}
document.addEventListener('n1cmp:render',function(){setTimeout(run,80)});
document.addEventListener('click',function(e){if(e.target.closest('.n1-compare .chip'))setTimeout(run,200)},true);
addEventListener('load',function(){setTimeout(run,700)});
setTimeout(run,1200);setTimeout(run,2400);
})();
